import { useState } from "react";

function useSelect(initialValue, onOptionChange) {
  const [selectedOption, setSelectedOption] = useState(initialValue);

  const handleOptionChange = (event) => {
    const newValue = event.target.value;
    setSelectedOption(newValue);
    if (onOptionChange) {
      onOptionChange(newValue);
    }
  };

  return { selectedOption, handleOptionChange };
}

export default useSelect;
